import { z } from 'zod';

// Asset types for preloading
const BasePreloadableAssetSchema = z.object({
  url: z.string(),
});

export enum PreloadableAssetType {
  Image = 'image',
  Font = 'font',
  Audio = 'audio',
}

export enum FontFormat {
  TTF = 'truetype',
  OTF = 'opentype',
}

export enum FontStyle {
  Normal = 'normal',
  Italic = 'italic',
}

export enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Normal = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
  Black = 900,
  VariableAll = '100..900',
  VariableRegularToBold = '400..700',
}

export const ImagePreloadableAssetSchema = BasePreloadableAssetSchema.extend({
  type: z.literal(PreloadableAssetType.Image),
});

export const FontPreloadableAssetSchema = BasePreloadableAssetSchema.extend({
  type: z.literal(PreloadableAssetType.Font),
  fontFamily: z.string(),
  fontWeight: z.nativeEnum(FontWeight),
  fontStyle: z.nativeEnum(FontStyle),
  fontFormat: z.nativeEnum(FontFormat),
});

export const AudioPreloadableAssetSchema = BasePreloadableAssetSchema.extend({
  type: z.literal(PreloadableAssetType.Audio),
});

export const PreloadableAssetSchema = z.discriminatedUnion('type', [
  ImagePreloadableAssetSchema,
  FontPreloadableAssetSchema,
  AudioPreloadableAssetSchema,
]);

export type PreloadableAsset = z.infer<typeof PreloadableAssetSchema>;
export type FontPreloadableAsset = z.infer<typeof FontPreloadableAssetSchema>;

export interface PreloadableAssetGroup {
  criticalAssets: PreloadableAsset[];
  lazyAssets: PreloadableAsset[];
}
